const EventInternalNav = ({activeTab, tabs, clickHandler}) => {
	let tabMarkup = [];

	for (const [key, value] of Object.entries(tabs)) {
		tabMarkup.push(
			<div
				id={`menu_item_${key}`}
				key={key}
				data-tab-for={key}
				onClick={() => clickHandler(key)}
				className={`tab ${key === activeTab ? 'active' : ''}`}
			>
				{value}
			</div>
		)
	}

	return tabMarkup

}

export default EventInternalNav;
